import { render, staticRenderFns } from "./actionItem.vue?vue&type=template&id=cb5f8504&scoped=true&"
import script from "./actionItem.vue?vue&type=script&lang=js&"
export * from "./actionItem.vue?vue&type=script&lang=js&"
import style0 from "./actionItem.vue?vue&type=style&index=0&id=cb5f8504&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb5f8504",
  null
  
)

export default component.exports